import { FC, useEffect, useState } from 'react'
import ShopProductApi from '../../../../infrastructure/api/ShopProductApi'
import { IShopProductModel } from '../../../../models/responses/ShopProductModel'
import { PagedResponseModel } from '../../../../models/responses/PagedResponseModel'
import { IPaginationFilter } from '../../../../models/requests/PaginationFilter'
import { GenericTable } from '../../../components/tables/GenericTable'
import { TableHelperButtons } from '../../../components/buttons/TableHelperButtons'
import { TableHelperButtonEnum } from '../../../enums/TableHelperButtonEnum'
import { ShopProductCategoryEnum } from '../../../../enums/ShopProductCategoryEnum'

type Props = {
  onClickItem: (itemId: any, itemName: string, type: string) => void
  refresh: number
}

const ShopProductListModal: FC<Props> = ({ onClickItem, refresh }) => {
  const [shopProducts, setShopProducts] = useState<PagedResponseModel<IShopProductModel[]>>()
  const [pageNumber, setPageNumber] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [searchText, setSearchText] = useState('')
  const [sort, setSort] = useState('stock_desc')

  useEffect(() => {
    const paginationFilter: IPaginationFilter = {
      page: pageNumber,
      size: pageSize,
      orderBy: sort,
      search: searchText,
    }
    async function getShopProducts() {
      var response = await ShopProductApi.GetShopProducts(paginationFilter)
      setShopProducts(response.data)
    }
    getShopProducts()
  }, [refresh, pageNumber, pageSize, searchText, sort])

  return (
    <>
      <GenericTable
        title='Shop Products'
        data={shopProducts?.items}
        currentTotalRecords={shopProducts?.totalRecords!!}
        currentPageNumber={shopProducts?.pageNumber!!}
        columns={[
          {
            label: '#',
            name: '#',
            options: {
              customBodyRenderLite: (dataIndex) => {
                return <>{(pageNumber - 1) * pageSize + ++dataIndex}</>
              },
              sort: false,
              viewColumns: false
            },
          },
          {
            label: 'ShopProduct',
            name: 'image',
            options: {
              customBodyRender: (value) => {
                return <img src={`${process.env.REACT_APP_CDN_URL}images/product/${value}`} width={80} />
              },
              sort: false
            },
          },
          {
            label: 'Name',
            name: 'name',
            options: {
              customBodyRender: (value) => {
                return <b>{value}</b>
              },
            },
          },
          {
            label: 'Category',
            name: 'category',
            options: {
              customBodyRender: (value) => {
                return (
                  <div className='d-flex align-items-center'>{ShopProductCategoryEnum[value]}</div>
                )
              },
            },
          },
          { label: 'Stock', name: 'stock' },
          { label: 'Edupoint', name: 'edupoint' },
          {
            label: '#',
            name: 'Id',
            options: {
              customHeadLabelRender: (options) => {
                return (
                  <div className='d-flex justify-content-end flex-shrink-0'>{options.label}</div>
                )
              },
              customBodyRenderLite: (dataIndex) => {
                return (
                  <TableHelperButtons
                    itemId={shopProducts?.items[dataIndex]?.id!!}
                    itemParam={shopProducts?.items[dataIndex]?.name!!}
                    types={[TableHelperButtonEnum.Update, TableHelperButtonEnum.Delete]}
                    onClickItem={onClickItem}
                  />
                )
              },
              filter: false,
              sort: false,
              viewColumns: false,
            },
          },
        ]}
        customOptions={{
          rowsPerPage: pageSize,
          customTableBodyFooterRender: (opts) => {
            return <div></div>
          },
        }}
        setPageNumber={setPageNumber}
        setPageSize={setPageSize}
        setSearchText={setSearchText}
        setSort={setSort}
      />
    </>
  )
}

export { ShopProductListModal }
